import { ReactNode, useState } from 'react';

import { useLocalStorage } from 'usehooks-ts';

import { ReturnComponentType } from 'common';
import { Header, ModalCompanyInfo, ModalEditUser, SideBar } from 'components';
import './Layout.scss';
import { useAppSelector } from 'hooks';
import { selectUser } from 'state';

type LayoutType = {
  children: ReactNode;
};
export const Layout = ({ children }: LayoutType): ReturnComponentType => {
  const [collapsed, setCollapsed] = useLocalStorage('sidebarCollapsed', false);
  const [showCompanyInfoModal, setShowCompanyInfoModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const user = useAppSelector(selectUser);

  return (
    <div className={`Layout ${collapsed ? 'Collapsed' : ''}`}>
      <SideBar
        setSidebarCollased={setCollapsed}
        sidebarCollapsed={collapsed}
        setShowCompanyInfoModal={setShowCompanyInfoModal}
        setShowEditUserModal={setShowEditUserModal}
      />
      <div className="Layout_Content">
        <Header />

        <div className="Layout_Content_Children">{children}</div>
      </div>

      {showCompanyInfoModal && (
        <ModalCompanyInfo
          showModal={showCompanyInfoModal}
          setShowModal={setShowCompanyInfoModal}
        />
      )}
      {showEditUserModal && (
        <ModalEditUser
          showModal={showEditUserModal}
          setShowModal={setShowEditUserModal}
          userId={user.id}
          isSelfManagement
        />
      )}
    </div>
  );
};
